import { Component, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { Router } from '@angular/router'
import { environment } from 'src/environments/environment'
import { ApiService } from './api.service'

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
	
	loggedIn = false
	userName = ''
	admin = false

	constructor(private dataService: ApiService, private router: Router, private title: Title) {}

	ngOnInit(): void {
		if (!this.loggedIn) {
			this.dataService.getLoggedInName
			.subscribe(
				loggedIn => {
					this.changeLogin(loggedIn)
					window.location.reload()
				}
			)
		}
	
		this.loggedIn = this.dataService.isLoggedIn()
		this.userName = this.dataService.getUserName()
		this.admin = this.dataService.getUserRole() == 1
		this.title.setTitle(environment.title)
	}

	private changeLogin(loggedIn: boolean): void {
		this.loggedIn = loggedIn
	}
	
	logout() {
		localStorage.clear()
		this.loggedIn = false
		this.router.navigate(['login'])
	}
}